import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import {
  BenchmarkingGoalEvolution,
  BenchmarkingPerformanceCards,
  BenchmarkingResultCards,
  BenchmarkingSchoolInfo,
} from '@/features/benchmarking';

export const Route = createFileRoute('/microdados/')({
  component: BenchmarkingOverviewTab,
});

function BenchmarkingOverviewTab(): JSX.Element {
  return (
    <>
      <BenchmarkingResultCards />
      <BenchmarkingSchoolInfo />
      <BenchmarkingPerformanceCards />
      <BenchmarkingGoalEvolution />
    </>
  );
}
